<template>
  <div>
    <b-modal
      v-model="showingIcsModal"
      title="Import your Tasks into your Calendar"
      :hide-footer="true"
    >
      <p class="mb-4">
        The URL below is the iCal Feed for your personal Redwood Calendar.
        This Calendar combines dates from your Listings, your Office, and
        other important sources into a single calendar that you can subscribe
        to from within your favorite Calendar app.
      </p>
      <div class="form-group">
        <div class="media">
          <div class="media-body">
            <input
              class="form-control"
              :value="icsUrl"
              readonly
            >
          </div>
          <div class="media-right">
            <share-button
              btn-class="btn btn-primary ml-2"
              icon="clipboard"
              :url="icsUrl"
            >
              Copy
            </share-button>
          </div>
        </div>
        <small class="form-text text-muted">
          Don't know how to subscribe to a calendar feed?
          <a href="https://new.accessredwood.com/support/guides/394" target="_blank">Read this guide</a>
        </small>
      </div>

      <hr>
      <div class="d-flex align-items-center justify-content-between">
        <b-checkbox
          v-model="dismissTasksIcsModal"
          size="sm"
        >
          Don't show this again
        </b-checkbox>
        <button
          class="btn btn-white btn-sm"
          @click="showingIcsModal = false"
        >
          Close
        </button>
      </div>
    </b-modal>

    <div class="row mb-4 d-flex">
      <tasks-search-input
       class="col-12 col-md-6 ml-auto"
      ></tasks-search-input>
    </div>

    <router-view
      :readonly="readonly"
    ></router-view>
  </div>
</template>

<style>
.editing-tasks {
  background-color: #ECF0F1 !important;
}
</style>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import { dismissTasksIcsModal } from '@/api'
import ShareButton from '@/components/ShareButton'
import TasksSearchInput from '@/components/TasksSearchInput'

export default {
  components: {
    ShareButton,
    TasksSearchInput
  },
  props: {
    showIcsModal: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      required: true
    },
    icsUrl: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      showingIcsModal: this.showIcsModal,
      dismissTasksIcsModal: false
    }
  },
  computed: {
    ...mapGetters('tasks', [
      'editingCount'
    ])
  },
  watch: {
    editingCount () {
      $('body').toggleClass('editing-tasks', this.editingCount > 0)
      $('#app').toggleClass('editing-tasks', this.editingCount > 0)
    },
    dismissTasksIcsModal (dismiss) {
      dismissTasksIcsModal(dismiss, this.userId)
    }
  }
}
</script>

